/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Draft_Media_PickInputs */

const cs_draft_media_pick = /** @type {(inputs: Draft_Media_PickInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vybrat obrázky`)
};

const en_draft_media_pick = /** @type {(inputs: Draft_Media_PickInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick images`)
};

/**
* | output |
* | --- |
* | "Pick images" |
*
* @param {Draft_Media_PickInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const draft_media_pick = /** @type {((inputs?: Draft_Media_PickInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Draft_Media_PickInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_draft_media_pick(inputs)
	return cs_draft_media_pick(inputs)
});